module.exports = __webpack_public_path__ + "img/9009307.jpg";